import { AxiosResponse } from 'axios';

import resolveV2 from '@/endpoints/resolverV2';

import { AcresFeature } from '../../../models/features';
import { SoilFeature } from '../../../models/soils';

export interface SchoolcraftSoilResponse {
  features: SoilFeature[];
  type: 'FeatureCollection';
}
interface IResponse extends AxiosResponse {
  data: SchoolcraftSoilResponse;
}

interface IResolvedSoil {
  res: IResponse | null;
  err: Error | null;
}

interface IData {
  boundary: AcresFeature;
}

export default async function getSoil(data: IData): Promise<IResolvedSoil> {
  return resolveV2(
    {
      data,
      method: 'POST',
      url: '/soil/productivity/',
    },
    {
      baseUrl: 'itasca',
    }
  );
}
